export default () => ({
    image_url: '',
    init() {
        // noinspection JSUnresolvedReference
        this.image_url = this.$root.getAttribute('data-dummy-thumbnail-url');
    },
    root: {
        ['x-bind:style']() {
            return {
                backgroundImage: this.image_url
                    ? `url('` + this.image_url + `')`
                    : null
            }
        },
        ['x-intersect.once']() {
            // noinspection JSUnresolvedReference
            this.image_url = this.$root.getAttribute('data-thumbnail-url');
        }
    }
});
